import { Button } from '@/components/ui/button';
import { parseSession } from '@/lib/parse-session';
import {
    Clock8Icon,
    Loader,
    LocateIcon,
    LucideLogOut,
    LucideNetwork,
} from 'lucide-react';

const SessionItem = (props: {
    loading?: boolean;
    userAgent: string;
    date: string;
    expiresAt: string;
    isCurrent?: boolean;
    ip: string;
    city: string;
    country: string;
    onRemove?: () => void;
}) => {
    const {
        userAgent,
        ip,
        city,
        country,
        loading,
        date,
        isCurrent = false,
        onRemove,
    } = props;
    const { os, browser, timeAgo, icon: Icon } = parseSession(userAgent, date);

    const handleRemove = () => {
        if (onRemove) {
            onRemove();
        }
    };

    return (
        <div className='w-full flex items-start '>
            <div
                className='shrink-0 mr-[16px] flex items-center justify-center
       w-[48px] h-[48px] rounded-full border dorder-[#eee] dark:border-[rgb(42,45,48)]'>
                <Icon />
            </div>
            <div className='flex-1 flex flex-col md:flex-row items-center justify-between'>
                <div className='flex-1 space-y-2'>
                    <h5 className='text-sm font-medium leading-1 mb-2'>
                        {os} / {browser}
                    </h5>
                    <h5 className='space-y-1'>
                        <span className='flex justify-start items-center gap-2 p-0 m-0 text-[13px] text-muted-foreground'>
                            <LucideNetwork className='inline-block size-4' />
                            {ip || 'Unknown IP'}
                        </span>{' '}
                        <span className='flex justify-start items-center gap-2 p-0 m-0 text-[13px] text-muted-foreground'>
                            <LocateIcon className='size-4' />
                            {city || 'Unknown City'} /{' '}
                            {country || 'Unknown Country'}
                        </span>
                    </h5>
                    <div className='flex items-center'>
                        {isCurrent ? (
                            <div
                                className='bg-fuchsia-900 h-[20px] px-2  mt-1
              flex items-center justify-center text-xs text-white rounded-lg'>
                                Active now
                            </div>
                        ) : (
                            <span className='flex justify-start items-center gap-2 p-0 m-0 text-[12px] text-muted-foreground font-normal'>
                                <Clock8Icon className='size-4' />{' '}
                                {timeAgo || 'date'}
                            </span>
                        )}
                    </div>
                </div>

                {!isCurrent && (
                    <Button
                        disabled={loading}
                        variant='ghost'
                        onClick={handleRemove}
                        title='Log out of this device'
                        className='max-w-[12rem] self-start my-4 !px-4 py-2 border-2 md:border-0'>
                        {loading ? (
                            <Loader className='size-4 animate-spin' />
                        ) : (
                            <>
                                <LucideLogOut className='hidden md:block !size-5' />
                                <span className='md:hidden text-left text-destructive font-bold'>
                                    Log out of this device
                                </span>
                            </>
                        )}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default SessionItem;
